import { gridPageChartPrecision } from 'shared/constants.json';

export const DEFAULT_DECIMAL_PLACES = 2;

const FORMAT_MODE = {
  automatic: 'automatic',
  fixed: 'fixed',
};

const PRECISION_TO_DIGITS = {
  [gridPageChartPrecision.precision0]: 0,
  [gridPageChartPrecision.precision1]: 1,
  [gridPageChartPrecision.precision2]: 2,
  [gridPageChartPrecision.precision3]: 3,
  [gridPageChartPrecision.precision4]: 4,
  [gridPageChartPrecision.precision5]: 5,
};

const resolvePrecision = (precision) => {
  if (precision === undefined || precision === null || precision === gridPageChartPrecision.precisionAutomatic) {
    return { mode: FORMAT_MODE.automatic, value: DEFAULT_DECIMAL_PLACES };
  }
  const digits = PRECISION_TO_DIGITS[precision];
  if (digits !== undefined) {
    return { mode: FORMAT_MODE.fixed, value: digits };
  }
  return { mode: FORMAT_MODE.automatic, value: DEFAULT_DECIMAL_PLACES };
};

// Intl.NumberFormat construction is expensive; reuse instances by config.
const formatterCache = new Map();
const getFormatter = (locale, mode, digits) => {
  const key = `${locale ?? ''}|${mode}|${digits}`;
  let formatter = formatterCache.get(key);
  if (formatter === undefined) {
    const options = mode === FORMAT_MODE.fixed
      ? { minimumFractionDigits: digits, maximumFractionDigits: digits }
      : { maximumFractionDigits: digits };
    formatter = new Intl.NumberFormat(locale, options);
    formatterCache.set(key, formatter);
  }
  return formatter;
};

export const getRoundedValue = (value, precision) => {
  const { value: digits } = resolvePrecision(precision);
  return Number.parseFloat(value).toFixed(digits);
};

export const formatChartNumber = (value, { precision, locale } = {}) => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) {
    return '';
  }
  const { mode, value: digits } = resolvePrecision(precision);
  return getFormatter(locale, mode, digits).format(Number(value));
};
